import {
    Box,
    Button,
    Flex,
    FormControl,
    FormLabel,
    Input,
    Text,
    Textarea,
    useToast
} from '@chakra-ui/react';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import EventsService from '../../api/services/EventsService';
import { useState } from "react";
import FileUploadInput from "../../components/FileUploadInput/FileUploadInput";

const validationSchema = Yup.object().shape({
    title: Yup.string().required('Wymagane'),
    parentTitle: Yup.string(),
    address: Yup.string().required('Wymagane'),
    date: Yup.string().required('Wymagane'),
    startTime: Yup.string().required('Wymagane'),
    endTime: Yup.string().required('Wymagane'),
    maxParticipants: Yup.number().positive().integer().required('Wymagane'),
    description: Yup.string(),
});

const AddEventForm = () => {
    const navigate = useNavigate();
    const toast = useToast();
    const [coverImage, setCoverImage] = useState(null);
    const [coverImageName, setCoverImageName] = useState(null);

    const handleUploadImage = async (file) => {
        try {
            const response = await EventsService.uploadCoverImage(file);
            setCoverImageName(file.name);
            setCoverImage(response.data);
        } catch (error) {
            toast({
                title: 'Błąd przy przesyłaniu zdjęcia',
                status: 'error',
                duration: 3000,
                isClosable: true,
            });
        }
    };

    const handleSubmit = async (values, actions) => {
        try {

            await EventsService.create({
                title: values.title,
                parentTitle: values.parentTitle,
                address: values.address,
                date: values.date,
                startTime: values.startTime,
                endTime: values.endTime,
                maxParticipants: values.maxParticipants,
                description: values.description,
                coverImage: coverImage,
                coverImageName: coverImageName
            });
            toast({
                title: 'Dodano wydarzenie',
                status: 'success',
                duration: 3000,
                isClosable: true,
            });
            navigate('/');
        } catch (error) {
            toast({
                title: 'Błąd przy dodawaniu',
                status: 'error',
                duration: 3000,
                isClosable: true,
            });
        } finally {
            actions.setSubmitting(false);
        }
    };

    return (
        <Flex w="100%" maxW="7xl" flexDirection="column" px={4} pr={16} py="80px">
            <Flex w="100%" maxW="7xl" flexDirection="row" className="nav-wrapper" gap="16px" onClick={() => navigate(`/`)} cursor={"pointer"}>
                <svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8 15.5L1 8.5M1 8.5L8 1.5M1 8.5H19" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <Text className="nav">
                    Dodaj nowe wydarzenie
                </Text>
            </Flex>
            <Flex w="100%" maxW="7xl" className="event">
                <Flex>
                    <Text className="title">
                        O wydarzeniu
                    </Text>
                </Flex>
                <Formik
                    initialValues={{
                        title: '',
                        parentTitle: '',
                        address: '',
                        date: '',
                        startTime: '',
                        endTime: '',
                        maxParticipants: '',
                        description: '',
                    }}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                >
                    {({ isSubmitting }) => (
                        <Form className="form">
                            <Flex direction={{ base: 'column', md: 'row' }} gap={6}>
                                <Box flex={1}>
                                    <FormControl mb={4}>
                                        <FormLabel>Główna nazwa wydarzenia</FormLabel>
                                        <Field as={Input} name="title" bg="white" borderRadius={0} />
                                    </FormControl>
                                    <FormControl mb={4}>
                                        <FormLabel>Nazwa wydarzenia nadrzędnego (opcjonalnie)</FormLabel>
                                        <Field as={Input} name="parentTitle" bg="white" borderRadius={0} />
                                    </FormControl>
                                    <FileUploadInput onFileSelect={handleUploadImage} />
                                    <FormControl mb={4}>
                                        <FormLabel>Adres wydarzenia</FormLabel>
                                        <Field as={Input} name="address" bg="white" borderRadius={0} />
                                    </FormControl>
                                    <Flex gap={4}>
                                        <FormControl mb={4}>
                                            <FormLabel>Data wydarzenia</FormLabel>
                                            <Field as={Input} name="date" type="date" bg="white" borderRadius={0} />
                                        </FormControl>
                                        <FormControl mb={4}>
                                            <FormLabel>Maksymalna ilość osób</FormLabel>
                                            <Field as={Input} name="maxParticipants" type="number" bg="white" borderRadius={0} />
                                        </FormControl>
                                    </Flex>
                                    <Flex gap={4}>
                                        <FormControl mb={4}>
                                            <FormLabel>Godzina rozpoczęcia</FormLabel>
                                            <Field as={Input} name="startTime" type="time" bg="white" borderRadius={0} />
                                        </FormControl>
                                        <FormControl mb={4}>
                                            <FormLabel>Godzina zakończenia</FormLabel>
                                            <Field as={Input} name="endTime" type="time" bg="white" borderRadius={0} />
                                        </FormControl>
                                    </Flex>
                                </Box>
                                <Box flex={1}>
                                    <FormControl mb={4}>
                                        <FormLabel>Opis wydarzenia</FormLabel>
                                        <Field as={Textarea} name="description" rows={17} bg="white" borderRadius={0} whiteSpace={"pre-wrap"} />
                                    </FormControl>
                                </Box>
                            </Flex>
                            <Flex justify="center" gap={4} mt={6}>
                                <Button variant="outline" borderRadius={0} onClick={() => navigate('/')} py="25px">Anuluj</Button>
                                <Button type="submit" isLoading={isSubmitting} bg="brand.500" color="white" borderRadius={0} _hover={{ bg: 'brand.600' }} px="48px" py="25px">
                                    Dodaj nowe wydarzenie
                                </Button>
                            </Flex>
                        </Form>
                    )}
                </Formik>
            </Flex>
        </Flex>
    );
};

export default AddEventForm;
